import { render, staticRenderFns } from "./_PlayerActivateForm.vue?vue&type=template&id=f26ddcf8&scoped=true&"
import script from "./_PlayerActivateForm.vue?vue&type=script&lang=ts&"
export * from "./_PlayerActivateForm.vue?vue&type=script&lang=ts&"
import style0 from "./_PlayerActivateForm.vue?vue&type=style&index=0&id=f26ddcf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f26ddcf8",
  null
  
)

export default component.exports